import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JumblesGameSelectorComponent } from './jumbles-game-selector/jumbles-game-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { JumblesGameCoreService } from './jumbles-game-core.service';

@NgModule({
  declarations: [JumblesGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [JumblesGameCoreService],
  exports: [JumblesGameSelectorComponent],
})
export class JumblesGameCoreModule {}
